<template>
  <!-- BEGIN: User Group User Modal -->
  <div id="user-group-users-viewer-modal" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="font-medium text-base mr-auto">
            組別用戶
          </h2>
        </div>
        <div class="modal-body p-0">
          <user-group-users-page :auth="auth" :current-site="currentSite" :permissions="permissions" :modal="true" :modal-group-id="viewGroupId" ref="userGroupUsersPage"></user-group-users-page>
          <div class="px-5 pb-8 text-center mt-4">
            <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">關閉</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: User Group User Modal -->
</template>

<script>
import UserGroupUsersPage from '@/page/management/UserGroupUsersPage.vue'

export default {
  components: { UserGroupUsersPage },
  props: ['auth', 'currentSite', 'permissions'],
  data() {
    return {
      viewGroupId: ''
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    onShow(groupId) {
      this.viewGroupId = groupId

      this.$refs.userGroupUsersPage.loadData(groupId)

      const el = document.querySelector('#user-group-users-viewer-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()

      setTimeout(() => {
        this.mounted = true
        window.tailwind.svgLoader()
      }, 100)
    }
  }
}
</script>
<style lang="scss" scoped>
#user-group-users-viewer-modal {
}
</style>
